export const dateToDDMMYYYY = (date: Date | undefined) => {
  if (date) {
    return date.toLocaleDateString('pt-BR').split('T')[0]
  }
  return null
}
